import axios from 'axios';

export const vaultApi = axios.create({
  baseURL: process.env.REACT_APP_VAULT_API_URL,
});

export const idmApi = axios.create({
  baseURL: process.env.REACT_APP_IDM_API_URL,
});
